export const isEmpty = (object: string | number | Date | null | undefined) =>
  object === undefined || object === null || object.toString().trim() === '';
